import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const discountsApi = createApi({
    reducerPath: 'discountsApi',
    tagTypes: ['discounts'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getDiscounts: build.query({
            query: (data) => ({
                url: api.discounts.getDiscounts(),
                method: 'GET',
                params: data
            }),
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return [endpointName, queryArgs?.location_id]
            },
            merge: (currentCache, newItems, { arg }) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                return currentArg !== previousArg;
            },
            providesTags: ['discounts']
        }),
        createDiscount: build.mutation({
            query: (data) => ({
                url: api.discounts.createDiscount(),
                method: 'POST',
                body: data
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(
                        discountsApi.util.updateQueryData('getDiscounts', patch, (draft) => {
                            draft.unshift(data)
                        })
                    )
                } catch (error) {
                    console.error('Failed to update cache:', error)
                }
            },
        }),
        updateDiscount: build.mutation({
            query: ({id, ...data}) => ({
                url: api.discounts.updateDiscount(id),
                method: 'PUT',
                body: data
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(
                        discountsApi.util.updateQueryData('getDiscounts',  {location_id: patch.location_id} , (draft) => {
                            const itemIndex = draft?.findIndex(item => item.id === patch.id)
                            if (itemIndex !== -1) {
                                draft[itemIndex] = data
                            }
                        })
                    )
                } catch(e) {
                    console.error('Update failed:', e)
                }
            },
        }),
        deleteDiscount: build.mutation({
            query: ({ id }) => ({
                url: api.discounts.deleteDiscount(id),
                method: 'DELETE',
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled
                    dispatch(
                        discountsApi.util.updateQueryData('getDiscounts', patch, (draft) => {
                            const index = draft.findIndex((discount) => discount.id === patch.id);
                            if (index !== -1) {
                                draft.splice(index, 1)
                            } else {
                                console.warn('Discount not found in cache')
                            }
                        })
                    );
                } catch (e) {
                    console.error('Delete failed:', e)
                }
            },
        }),
    })
})

export const { useDeleteDiscountMutation } = discountsApi